import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from 'recharts';
export const StaffingRatioChart: React.FC = () => {
  // Sample data for staffing ratios across facilities
  const data = [{
    facility: 'Harbor View',
    ratio: 2.52,
    careHours: 4.2,
    industryAvgRatio: 3.0,
    industryAvgCare: 3.5
  }, {
    facility: 'Sunset Meadows',
    ratio: 2.8,
    careHours: 3.5,
    industryAvgRatio: 3.0,
    industryAvgCare: 3.5
  }, {
    facility: 'Lakeside Gardens',
    ratio: 2.95,
    careHours: 3.8,
    industryAvgRatio: 3.0,
    industryAvgCare: 3.5
  }, {
    facility: 'Mountain Terrace',
    ratio: 2.95,
    careHours: 3.6,
    industryAvgRatio: 3.0,
    industryAvgCare: 3.5
  }, {
    facility: 'Parkside Manor',
    ratio: 3.18,
    careHours: 3.2,
    industryAvgRatio: 3.0,
    industryAvgCare: 3.5
  }];
  return <ResponsiveContainer width="100%" height="100%" data-id="element-73">
      <BarChart data={data} margin={{
      top: 20,
      right: 30,
      left: 20,
      bottom: 5
    }} data-id="element-74">
        <CartesianGrid strokeDasharray="3 3" data-id="element-75" />
        <XAxis dataKey="facility" data-id="element-76" />
        <YAxis yAxisId="left" orientation="left" domain={[0, 4]} data-id="element-77" />
        <YAxis yAxisId="right" orientation="right" domain={[0, 5]} data-id="element-78" />
        <Tooltip data-id="element-79" />
        <Legend data-id="element-80" />
        <ReferenceLine yAxisId="left" y={3.0} stroke="#8884d8" strokeDasharray="3 3" label={{
        position: 'top',
        value: 'Industry Avg Ratio',
        fill: '#8884d8',
        fontSize: 10
      }} data-id="element-81" />
        <ReferenceLine yAxisId="right" y={3.5} stroke="#82ca9d" strokeDasharray="3 3" label={{
        position: 'top',
        value: 'Industry Avg Hours',
        fill: '#82ca9d',
        fontSize: 10
      }} data-id="element-82" />
        <Bar yAxisId="left" dataKey="ratio" name="Resident:Staff Ratio" fill="#1f58b0" radius={[4, 4, 0, 0]} data-id="element-83" />
        <Bar yAxisId="right" dataKey="careHours" name="Care Hours per Resident" fill="#f6d052" radius={[4, 4, 0, 0]} data-id="element-84" />
      </BarChart>
    </ResponsiveContainer>;
};